export default __webpack_public_path__ + "static/assets/8728d4bc835992c117dd884cd843a714.png";